import type React from "react";
import {isUnderConstructionMode} from "../../../utils/underConstructionMode.ts";
import {useStores} from "../../../stores";
import {Alert, AlertTitle} from "@mui/material";

export const HeaderAlert: React.FC = () => {
    const {authStore} = useStores();
    if (isUnderConstructionMode(authStore)) {
        return <Alert severity="error" style={{flexGrow: '1'}}>
            <AlertTitle>
                We are currently under maintenance
            </AlertTitle>
            Some features may be unavailable.
        </Alert>
    }
    return null
}
